import CloseIconBlack from "../../assets/Svg/CloseIconBlack.svg";
const CloseButton = ({ width = '12px', height = '12px', onClick = null}) => {
    return (
        <img src={CloseIconBlack} width={width} height={height} onClick={onClick} alt="" />
    )
}
export default CloseButton